const data = {
    table: {
        columns: [
            {title: 'No.', field: 'id', width: '140'},
            {title: '名称', field: 'name', width: '200'},
            {title: '联系电话', field: 'contact', width: ''},
            {title: '地址', field: 'addr', width: '200'},
            {title: '备注', field: 'remarks', width: ''}
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    }
}

export default data
